module.exports = __webpack_public_path__ + "static/media/attachment.cd20642c.svg";